import React from 'react';
import {MasterLayout} from 'components/layouts';
import {ListCategory} from 'components/list-category';
import title from 'constants/TitlePages.js';

class ListCategoryPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.ListCategoryPage;
  }

  render() {
    return (
      <MasterLayout>
        <ListCategory params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default ListCategoryPage;



// WEBPACK FOOTER //
// ./pages/list-category/ListCategoryPage.jsx